// Sign-up: entity + team, role requests, partner accounts waiting, the team → role table (Jay tasks #1160 / #1155, 02/11/2026).
const en = {
  offHint: "Switched off: no longer offered at sign-up or on Edit user; the {{n}} people in it keep it until someone changes them.",
  salesOpLocked: "A Sales OP team stays on: Project Tracker, quotes and tickets depend on it.",
  keyHint: "Letters and digits; empty = made from the name. It is stored on everybody in the department, so it does not change later.",
  keyLabel: "Key",
  colMembers: "People",
  tabAccounts: 'Account requests',
  tabRoles: 'Role requests',
  tabPartners: 'Partner accounts',
  tabTeams: 'Teams & roles',
  // the person's own card on Home
  welcomeT: 'Welcome to HEVN Portal — which team are you in?',
  welcomeB: 'Pick your company and team. You can use the portal with the User role now; the role your team needs opens once Jay or Max approves it.',
  entity: 'Company',
  team: 'Team',
  pick: 'Pick…',
  asks: 'Your team asks for: {{role}}',
  asksNone: 'Your team uses the User role — nothing to approve.',
  save: 'Save',
  saving: 'Saving…',
  pendingT: 'Role approval pending',
  pendingB: 'You asked for {{role}} ({{team}}). Until Jay or Max approves it you have the User role.',
  approvedT: 'Your role is approved: {{role}}',
  rejectedT: 'Your role request was not approved',
  dismiss: 'OK',
  // Role requests
  rrIntro: 'People who picked a team at sign-up and ask for its role. Approve it, approve another role, or reject with a reason. The role works from the person\'s next page load.',
  colPerson: 'Person',
  colEntity: 'Company',
  colTeam: 'Team',
  colAsked: 'Asks for',
  colStatus: 'Status',
  colWhen: 'When',
  colDecided: 'Decided',
  colActions: 'Actions',
  approve: 'Approve',
  reject: 'Reject',
  roleToGive: 'Role to give',
  reason: 'Reason (the person reads it)',
  confirmReject: 'Reject',
  cancel: 'Cancel',
  waiting: 'Waiting ({{n}})',
  decided: 'Decided',
  none: 'Nothing waiting.',
  st_pending: 'Waiting',
  st_needs_team: 'Has not picked a team',
  st_approved: 'Approved',
  st_rejected: 'Rejected',
  // Partner accounts
  paIntro: 'Accounts made by a partner\'s first Google sign-in (outside @helinox.com). They cannot sign in until you approve them; rejecting switches the account off.',
  colEmail: 'Email',
  colOrg: 'Partner',
  colCreated: 'Signed up',
  // Teams & roles
  trIntro: "The portal's departments — one list for sign-up, Edit user, Project Tracker and Catchy. A newcomer picks one at sign-up and asks for its role; approval and system roles (Admin, CEO, CEO Desk, S.OP Manager, Staff Purchase Admin, Driver, External Vendor, Integration) cannot be asked for. Switch a department off, never delete it.",
  colRole: 'Asks for role',
  colDept: 'Department',
  colOrder: 'Order',
  colActive: 'In use',
  userRole: 'User (nothing to approve)',
  noDept: '—',
  add: 'Add team',
  newTeam: 'New team name',
  saved: 'Saved.',
  // To assign (Users list)
  toAssign: 'To assign ({{n}})',
  toAssignTitle: 'Active accounts with no entity or no department',
  editTeam: 'Edit team — {{name}}',
  edit: 'Edit',
  roleHint: 'The role this team asks for at sign-up; Jay or Max still approves it. "User" means nothing to approve.',
  noDeptLong: '— none —',
  deptHint: 'The portal department the person is put in when they pick this team.',
  inUseLong: "In use (sign-up, Edit user, Project Tracker)",
  inUse: 'In use',
  off: 'Off',
  userShort: 'User',
  allCompanies: 'All',
  clearFilters: 'Clear filters',
  shownOf: '{{n}} of {{m}} shown',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  teamsN: '{{n}} teams',
  teamsOf: '{{n}} of {{m}} teams',
};

const ko = {
  offHint: "끄면 가입과 사용자 수정에서 더 이상 보이지 않으며, 소속된 {{n}}명은 누군가 바꾸기 전까지 그대로 유지됩니다.",
  salesOpLocked: "Sales OP 팀은 끌 수 없습니다: Project Tracker, 견적, 티켓이 이 팀에 연결되어 있습니다.",
  keyHint: "영문과 숫자. 비워 두면 이름으로 만듭니다. 부서의 모든 사람에게 저장되므로 나중에 바뀌지 않습니다.",
  keyLabel: "키",
  colMembers: "인원",
  tabAccounts: '계정 요청',
  tabRoles: '역할 요청',
  tabPartners: '파트너 계정',
  tabTeams: '팀 및 역할',
  welcomeT: 'HEVN Portal에 오신 것을 환영합니다 — 어느 팀이신가요?',
  welcomeB: '회사와 팀을 선택하세요. 지금은 User 역할로 포털을 사용할 수 있고, 팀에 필요한 역할은 Jay 또는 Max가 승인하면 열립니다.',
  entity: '회사',
  team: '팀',
  pick: '선택…',
  asks: '팀이 요청하는 역할: {{role}}',
  asksNone: '이 팀은 User 역할을 사용합니다 — 승인할 것이 없습니다.',
  save: '저장',
  saving: '저장 중…',
  pendingT: '역할 승인 대기 중',
  pendingB: '{{role}}({{team}})을 요청했습니다. Jay 또는 Max가 승인할 때까지 User 역할입니다.',
  approvedT: '역할이 승인되었습니다: {{role}}',
  rejectedT: '역할 요청이 승인되지 않았습니다',
  dismiss: '확인',
  rrIntro: '가입 시 팀을 고르고 그 팀의 역할을 요청한 사람들입니다. 승인하거나, 다른 역할로 승인하거나, 이유와 함께 거절하세요. 역할은 그 사람이 다음 페이지를 열 때부터 적용됩니다.',
  colPerson: '사람',
  colEntity: '회사',
  colTeam: '팀',
  colAsked: '요청 역할',
  colStatus: '상태',
  colWhen: '일시',
  colDecided: '결정',
  colActions: '작업',
  approve: '승인',
  reject: '거절',
  roleToGive: '부여할 역할',
  reason: '이유 (요청자가 읽습니다)',
  confirmReject: '거절',
  cancel: '취소',
  waiting: '대기 ({{n}})',
  decided: '결정됨',
  none: '대기 중인 요청이 없습니다.',
  st_pending: '대기',
  st_needs_team: '팀 미선택',
  st_approved: '승인',
  st_rejected: '거절',
  paIntro: '파트너가 처음 Google로 로그인해 만들어진 계정(@helinox.com 외)입니다. 승인 전에는 로그인할 수 없고, 거절하면 계정이 비활성화됩니다.',
  colEmail: '이메일',
  colOrg: '파트너',
  colCreated: '가입',
  trIntro: "포털의 부서 목록 — 가입, 사용자 수정, Project Tracker, Catchy가 함께 쓰는 하나의 목록입니다. 신규 사용자는 가입 시 부서를 고르고 그 역할을 요청합니다. 승인·시스템 역할(Admin, CEO, CEO Desk, S.OP Manager, Staff Purchase Admin, Driver, External Vendor, Integration)은 요청할 수 없습니다. 부서는 삭제하지 않고 끄기만 합니다.",
  colRole: '요청 역할',
  colDept: '부서',
  colOrder: '순서',
  colActive: '사용',
  userRole: 'User (승인 불필요)',
  noDept: '—',
  add: '팀 추가',
  newTeam: '새 팀 이름',
  saved: '저장했습니다.',
  toAssign: '배정 필요 ({{n}})',
  toAssignTitle: '회사 또는 부서가 없는 활성 계정',
  editTeam: '팀 수정 — {{name}}',
  edit: '수정',
  roleHint: '가입 시 이 팀이 요청하는 역할입니다. Jay 또는 Max가 승인합니다. "User"는 승인할 것이 없다는 뜻입니다.',
  noDeptLong: '— 없음 —',
  deptHint: '이 팀을 고르면 들어가는 포털 부서입니다.',
  inUseLong: "사용 중 (가입, 사용자 수정, Project Tracker)",
  inUse: '사용',
  off: '꺼짐',
  userShort: 'User',
  allCompanies: '전체',
  clearFilters: '필터 지우기',
  shownOf: '{{m}}개 중 {{n}}개 표시',
  expandAll: '모두 펼치기',
  collapseAll: '모두 접기',
  teamsN: '팀 {{n}}개',
  teamsOf: '팀 {{m}}개 중 {{n}}개',
};

const vi = {
  offHint: "Tắt thì không còn hiện khi đăng ký hay ở Edit user; {{n}} người đang trong department vẫn giữ cho tới khi có người đổi.",
  salesOpLocked: "Team Sales OP luôn bật: Project Tracker, báo giá và ticket phụ thuộc vào nó.",
  keyHint: "Chữ và số; để trống thì tạo từ tên. Mã được lưu trên mọi người trong department nên sau này không đổi.",
  keyLabel: "Mã",
  colMembers: "Số người",
  tabAccounts: 'Yêu cầu tài khoản',
  tabRoles: 'Yêu cầu role',
  tabPartners: 'Tài khoản đối tác',
  tabTeams: 'Team & role',
  welcomeT: 'Chào mừng đến HEVN Portal — anh chị thuộc team nào?',
  welcomeB: 'Chọn công ty và team của anh chị. Bây giờ anh chị dùng portal với role User; role mà team cần sẽ mở khi Jay hoặc Max duyệt.',
  entity: 'Công ty',
  team: 'Team',
  pick: 'Chọn…',
  asks: 'Team của anh chị xin role: {{role}}',
  asksNone: 'Team này dùng role User — không cần duyệt.',
  save: 'Lưu',
  saving: 'Đang lưu…',
  pendingT: 'Role đang chờ duyệt',
  pendingB: 'Anh chị đã xin role {{role}} ({{team}}). Trong lúc chờ Jay hoặc Max duyệt, anh chị dùng role User.',
  approvedT: 'Role của anh chị đã được duyệt: {{role}}',
  rejectedT: 'Yêu cầu role chưa được duyệt',
  dismiss: 'OK',
  rrIntro: 'Những người đã chọn team khi đăng ký và xin role của team đó. Duyệt, duyệt role khác, hoặc từ chối kèm lý do. Role có hiệu lực từ trang tiếp theo người đó mở.',
  colPerson: 'Người',
  colEntity: 'Công ty',
  colTeam: 'Team',
  colAsked: 'Xin role',
  colStatus: 'Trạng thái',
  colWhen: 'Lúc',
  colDecided: 'Quyết định',
  colActions: 'Thao tác',
  approve: 'Duyệt',
  reject: 'Từ chối',
  roleToGive: 'Role cấp',
  reason: 'Lý do (người xin sẽ đọc)',
  confirmReject: 'Từ chối',
  cancel: 'Hủy',
  waiting: 'Đang chờ ({{n}})',
  decided: 'Đã quyết định',
  none: 'Không có yêu cầu nào đang chờ.',
  st_pending: 'Đang chờ',
  st_needs_team: 'Chưa chọn team',
  st_approved: 'Đã duyệt',
  st_rejected: 'Từ chối',
  paIntro: 'Tài khoản do đối tác tự tạo khi đăng nhập Google lần đầu (ngoài @helinox.com). Chưa đăng nhập được cho tới khi anh duyệt; từ chối thì tài khoản bị khóa.',
  colEmail: 'Email',
  colOrg: 'Đối tác',
  colCreated: 'Đăng ký',
  trIntro: "Danh sách department của portal — một danh sách dùng chung cho đăng ký, Edit user, Project Tracker và Catchy. Người mới chọn một department khi đăng ký và xin role của nó; không xin được các role duyệt và hệ thống (Admin, CEO, CEO Desk, S.OP Manager, Staff Purchase Admin, Driver, External Vendor, Integration). Department chỉ tắt, không xóa.",
  colRole: 'Xin role',
  colDept: 'Department',
  colOrder: 'Thứ tự',
  colActive: 'Đang dùng',
  userRole: 'User (không cần duyệt)',
  noDept: '—',
  add: 'Thêm team',
  newTeam: 'Tên team mới',
  saved: 'Đã lưu.',
  toAssign: 'Cần gán ({{n}})',
  toAssignTitle: 'Tài khoản đang hoạt động chưa có entity hoặc department',
  editTeam: 'Sửa team — {{name}}',
  edit: 'Sửa',
  roleHint: 'Role team này xin khi đăng ký; Jay hoặc Max vẫn phải duyệt. "User" nghĩa là không cần duyệt.',
  noDeptLong: '— không —',
  deptHint: 'Department trên portal mà người chọn team này được đưa vào.',
  inUseLong: "Đang dùng (đăng ký, Edit user, Project Tracker)",
  inUse: 'Đang dùng',
  off: 'Tắt',
  userShort: 'User',
  allCompanies: 'Tất cả',
  clearFilters: 'Xóa lọc',
  shownOf: 'Đang hiện {{n}} / {{m}}',
  expandAll: 'Mở tất cả',
  collapseAll: 'Đóng tất cả',
  teamsN: '{{n}} team',
  teamsOf: '{{n}} / {{m}} team',
};

const zh = {
  offHint: "关闭后不再在注册和编辑用户中显示；部门中的 {{n}} 人保持不变，直到有人修改。",
  salesOpLocked: "Sales OP 团队保持开启：Project Tracker、报价和工单都依赖它。",
  keyHint: "字母和数字；留空则由名称生成。它保存在部门中每个人的记录上，之后不会改变。",
  keyLabel: "代码",
  colMembers: "人数",
  tabAccounts: '账户申请',
  tabRoles: '角色申请',
  tabPartners: '合作伙伴账户',
  tabTeams: '团队与角色',
  welcomeT: '欢迎使用 HEVN Portal — 您在哪个团队？',
  welcomeB: '请选择您的公司和团队。现在您可以以 User 角色使用门户；团队所需的角色在 Jay 或 Max 批准后开放。',
  entity: '公司',
  team: '团队',
  pick: '请选择…',
  asks: '您的团队申请的角色：{{role}}',
  asksNone: '此团队使用 User 角色 — 无需审批。',
  save: '保存',
  saving: '保存中…',
  pendingT: '角色待审批',
  pendingB: '您申请了 {{role}}（{{team}}）。在 Jay 或 Max 批准之前，您使用 User 角色。',
  approvedT: '您的角色已批准：{{role}}',
  rejectedT: '您的角色申请未获批准',
  dismiss: '确定',
  rrIntro: '注册时选择了团队并申请该团队角色的人员。可批准、改为其他角色批准，或填写理由后拒绝。角色从此人下一次打开页面起生效。',
  colPerson: '人员',
  colEntity: '公司',
  colTeam: '团队',
  colAsked: '申请角色',
  colStatus: '状态',
  colWhen: '时间',
  colDecided: '决定',
  colActions: '操作',
  approve: '批准',
  reject: '拒绝',
  roleToGive: '授予角色',
  reason: '理由（申请人可见）',
  confirmReject: '拒绝',
  cancel: '取消',
  waiting: '待处理（{{n}}）',
  decided: '已决定',
  none: '没有待处理的申请。',
  st_pending: '待处理',
  st_needs_team: '未选择团队',
  st_approved: '已批准',
  st_rejected: '已拒绝',
  paIntro: '合作伙伴首次用 Google 登录时创建的账户（@helinox.com 以外）。在您批准前无法登录；拒绝则停用该账户。',
  colEmail: '邮箱',
  colOrg: '合作伙伴',
  colCreated: '注册时间',
  trIntro: "门户的部门列表——注册、编辑用户、Project Tracker 和 Catchy 共用的同一列表。新用户注册时选择部门并申请其角色；审批和系统角色（Admin、CEO、CEO Desk、S.OP Manager、Staff Purchase Admin、Driver、External Vendor、Integration）不可申请。部门只能关闭，不能删除。",
  colRole: '申请角色',
  colDept: '部门',
  colOrder: '顺序',
  colActive: '启用',
  userRole: 'User（无需审批）',
  noDept: '—',
  add: '添加团队',
  newTeam: '新团队名称',
  saved: '已保存。',
  toAssign: '待分配（{{n}}）',
  toAssignTitle: '没有公司或部门的活跃账户',
  editTeam: '编辑团队 — {{name}}',
  edit: '编辑',
  roleHint: '此团队在注册时申请的角色；仍需 Jay 或 Max 批准。"User" 表示无需审批。',
  noDeptLong: '— 无 —',
  deptHint: '选择此团队的人员将被放入的门户部门。',
  inUseLong: "使用中（注册、编辑用户、Project Tracker）",
  inUse: '启用',
  off: '停用',
  userShort: 'User',
  allCompanies: '全部',
  clearFilters: '清除筛选',
  shownOf: '显示 {{n}} / {{m}}',
  expandAll: '全部展开',
  collapseAll: '全部收起',
  teamsN: '{{n}} 个团队',
  teamsOf: '{{n}} / {{m}} 个团队',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "offHint": "Désactivé : n'est plus proposé à l'inscription ni dans Modifier l'utilisateur ; les {{n}} personnes concernées le conservent tant que personne ne les modifie.",
  "salesOpLocked": "Une équipe Sales OP reste active : Project Tracker, les devis et les tickets en dépendent.",
  "keyHint": "Lettres et chiffres ; vide = généré à partir du nom. Il est enregistré pour tous les membres du département, il ne change donc plus ensuite.",
  "keyLabel": "Clé",
  "colMembers": "Personnes",
  "tabAccounts": "Demandes de compte",
  "tabRoles": "Demandes de rôle",
  "tabPartners": "Comptes partenaires",
  "tabTeams": "Équipes et rôles",
  "welcomeT": "Bienvenue sur HEVN Portal — dans quelle équipe êtes-vous ?",
  "welcomeB": "Choisissez votre société et votre équipe. Vous pouvez utiliser le portail dès maintenant avec le rôle User ; le rôle dont votre équipe a besoin sera ouvert dès que Jay ou Max l'aura approuvé.",
  "entity": "Société",
  "team": "Équipe",
  "pick": "Choisir…",
  "asks": "Votre équipe demande : {{role}}",
  "asksNone": "Votre équipe utilise le rôle User — rien à approuver.",
  "save": "Enregistrer",
  "saving": "Enregistrement…",
  "pendingT": "Approbation du rôle en attente",
  "pendingB": "Vous avez demandé {{role}} ({{team}}). Tant que Jay ou Max ne l'a pas approuvé, vous avez le rôle User.",
  "approvedT": "Votre rôle est approuvé : {{role}}",
  "rejectedT": "Votre demande de rôle n'a pas été approuvée",
  "dismiss": "OK",
  "rrIntro": "Personnes qui ont choisi une équipe à l'inscription et demandent son rôle. Approuvez-le, approuvez un autre rôle, ou rejetez avec un motif. Le rôle prend effet au prochain chargement de page de la personne.",
  "colPerson": "Personne",
  "colEntity": "Société",
  "colTeam": "Équipe",
  "colAsked": "Demande",
  "colStatus": "Statut",
  "colWhen": "Date",
  "colDecided": "Décision",
  "colActions": "Actions",
  "approve": "Approuver",
  "reject": "Rejeter",
  "roleToGive": "Rôle à attribuer",
  "reason": "Motif (la personne le lira)",
  "confirmReject": "Rejeter",
  "cancel": "Annuler",
  "waiting": "En attente ({{n}})",
  "decided": "Traitées",
  "none": "Rien en attente.",
  "st_pending": "En attente",
  "st_needs_team": "N'a pas choisi d'équipe",
  "st_approved": "Approuvé",
  "st_rejected": "Rejeté",
  "paIntro": "Comptes créés par la première connexion Google d'un partenaire (hors @helinox.com). Ils ne peuvent pas se connecter tant que vous ne les avez pas approuvés ; le rejet désactive le compte.",
  "colEmail": "E-mail",
  "colOrg": "Partenaire",
  "colCreated": "Inscrit le",
  "trIntro": "Les départements du portail — une seule liste pour l'inscription, Modifier l'utilisateur, Project Tracker et Catchy. Un nouvel arrivant en choisit un à l'inscription et demande son rôle ; l'approbation et les rôles système (Admin, CEO, CEO Desk, S.OP Manager, Staff Purchase Admin, Driver, External Vendor, Integration) ne peuvent pas être demandés. Désactivez un département, ne le supprimez jamais.",
  "colRole": "Rôle demandé",
  "colDept": "Département",
  "colOrder": "Ordre",
  "colActive": "Utilisé",
  "userRole": "User (rien à approuver)",
  "noDept": "—",
  "add": "Ajouter une équipe",
  "newTeam": "Nom de la nouvelle équipe",
  "saved": "Enregistré.",
  "toAssign": "À affecter ({{n}})",
  "toAssignTitle": "Comptes actifs sans société ou sans département",
  "editTeam": "Modifier l'équipe — {{name}}",
  "edit": "Modifier",
  "roleHint": "Le rôle que cette équipe demande à l'inscription ; Jay ou Max l'approuve toujours. « User » signifie rien à approuver.",
  "noDeptLong": "— aucun —",
  "deptHint": "Le département du portail dans lequel la personne est placée lorsqu'elle choisit cette équipe.",
  "inUseLong": "Utilisé (inscription, Modifier l'utilisateur, Project Tracker)",
  "inUse": "Utilisé",
  "off": "Désactivé",
  "userShort": "User",
  "allCompanies": "Toutes",
  "clearFilters": "Effacer les filtres",
  "shownOf": "{{n}} sur {{m}} affichés",
  "expandAll": "Tout développer",
  "collapseAll": "Tout réduire",
  "teamsN": "{{n}} équipes",
  "teamsOf": "{{n}} équipes sur {{m}}"
};
const ja = {
  "offHint": "オフ：サインアップやユーザー編集では選択肢に表示されません。所属する {{n}} 人は、誰かが変更するまでそのまま保持されます。",
  "salesOpLocked": "Sales OP チームは有効のままにします：Project Tracker、見積、チケットがこれに依存しています。",
  "keyHint": "英字と数字。空欄の場合は名称から作成されます。部門の全員に保存されるため、後から変わることはありません。",
  "keyLabel": "キー",
  "colMembers": "人数",
  "tabAccounts": "アカウント申請",
  "tabRoles": "ロール申請",
  "tabPartners": "パートナーアカウント",
  "tabTeams": "チームとロール",
  "welcomeT": "HEVN Portal へようこそ — どのチームに所属していますか？",
  "welcomeB": "会社とチームを選んでください。今すぐ User ロールでポータルを利用できます。チームに必要なロールは、Jay または Max が承認すると使えるようになります。",
  "entity": "会社",
  "team": "チーム",
  "pick": "選択…",
  "asks": "チームの申請ロール：{{role}}",
  "asksNone": "チームは User ロールを使用します — 承認は不要です。",
  "save": "保存",
  "saving": "保存中…",
  "pendingT": "ロールの承認待ち",
  "pendingB": "{{role}}（{{team}}）を申請しました。Jay または Max が承認するまでは User ロールです。",
  "approvedT": "ロールが承認されました：{{role}}",
  "rejectedT": "ロール申請は承認されませんでした",
  "dismiss": "OK",
  "rrIntro": "サインアップ時にチームを選び、そのロールを申請した人の一覧です。承認する、別のロールで承認する、または理由を添えて却下します。ロールは本人の次回のページ読み込みから有効になります。",
  "colPerson": "申請者",
  "colEntity": "会社",
  "colTeam": "チーム",
  "colAsked": "申請ロール",
  "colStatus": "ステータス",
  "colWhen": "日時",
  "colDecided": "決定",
  "colActions": "操作",
  "approve": "承認",
  "reject": "却下",
  "roleToGive": "付与するロール",
  "reason": "理由（本人に表示されます）",
  "confirmReject": "却下",
  "cancel": "キャンセル",
  "waiting": "待機中 ({{n}})",
  "decided": "決定済み",
  "none": "待機中のものはありません。",
  "st_pending": "待機中",
  "st_needs_team": "チーム未選択",
  "st_approved": "承認済み",
  "st_rejected": "却下",
  "paIntro": "パートナーが初めてGoogleでサインインしたときに作成されたアカウント（@helinox.com 以外）です。承認するまでサインインできません。却下するとアカウントは無効になります。",
  "colEmail": "メール",
  "colOrg": "パートナー",
  "colCreated": "サインアップ日",
  "trIntro": "ポータルの部門一覧です — サインアップ、ユーザー編集、Project Tracker、Catchy で共通の1つのリストです。新規ユーザーはサインアップ時に1つ選び、そのロールを申請します。承認とシステムロール（Admin、CEO、CEO Desk、S.OP Manager、Staff Purchase Admin、Driver、External Vendor、Integration）は申請できません。部門は削除せず、無効にしてください。",
  "colRole": "申請するロール",
  "colDept": "部門",
  "colOrder": "順序",
  "colActive": "使用中",
  "userRole": "User（承認不要）",
  "noDept": "—",
  "add": "チームを追加",
  "newTeam": "新しいチーム名",
  "saved": "保存しました。",
  "toAssign": "割り当て待ち ({{n}})",
  "toAssignTitle": "会社または部門が未設定の有効なアカウント",
  "editTeam": "チームを編集 — {{name}}",
  "edit": "編集",
  "roleHint": "このチームがサインアップ時に申請するロールです。承認は引き続き Jay または Max が行います。「User」は承認不要を意味します。",
  "noDeptLong": "— なし —",
  "deptHint": "このチームを選んだ人が所属することになるポータルの部門です。",
  "inUseLong": "使用中（サインアップ、ユーザー編集、Project Tracker）",
  "inUse": "使用中",
  "off": "オフ",
  "userShort": "User",
  "allCompanies": "すべて",
  "clearFilters": "フィルターをクリア",
  "shownOf": "{{m}} 件中 {{n}} 件を表示",
  "expandAll": "すべて展開",
  "collapseAll": "すべて折りたたむ",
  "teamsN": "{{n}} チーム",
  "teamsOf": "{{m}} チーム中 {{n}} チーム"
};

const dictionary = { ns: 'xSignup', en, ko, vi, zh, fr, ja };

export default dictionary;
